import { MerchantPpPlusClaimMode } from "@redotech/cockroachdb-codegen/congodb/merchant-pp-plus-claim-mode";
import * as z from "zod";

export const createCustomerAuthToken = {
  name: "createCustomerAuthToken" as const,
  input: z.object({
    auth: z
      .object({ email: z.string() })
      .nullish()
      .or(z.object({ orderId: z.string() }))
      .nullish(),
    email: z.string().nullish(), // TODO(devin) remove this (have to keep for backwards compatibility)
    /** Team to mint the token for: the caller's own team (default) or a merchant it manages as a 3PL. */
    teamId: z.string().nullish(),
    isMerchantCreated: z.boolean().nullish(),
    merchantName: z.string().nullish(),
    merchantRoles: z.array(z.string()).nullish(),
    /** PP+ documentation choice for a merchant-created claim. */
    merchantPpPlusClaimMode: z.enum(MerchantPpPlusClaimMode).nullish(),
    isGift: z.boolean().nullish(),
  }),
  output: z.object({ token: z.string(), customerId: z.string().nullish() }),
};
